/* Open Fuel – product gallery dots
   Builds a dot per slide under the main image and keeps it in sync with both
   gallery engines the Shapes theme uses (desktop: Alpine / thumbnails,
   mobile: Splide). */
(function () {
  var DESKTOP = window.matchMedia('(min-width: 1024px)');

  function init() {
    var pm = document.querySelector('.product-media');
    if (!pm) return;
    var sp = pm.querySelector('.splide--product');
    var list = pm.querySelector('.feature-media-list');
    if (!sp || !list || sp.querySelector('.of-dots')) return;

    var slides = Array.prototype.slice.call(pm.querySelectorAll('.feature-media-item'));
    var thumbs = pm.querySelectorAll('.media-thumbnail');
    if (slides.length < 2) return;

    var wrap = document.createElement('div');
    wrap.className = 'of-dots';
    var dots = slides.map(function (_, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Go to image ' + (i + 1));
      b.addEventListener('click', function () { goTo(i); });
      wrap.appendChild(b);
      return b;
    });
    sp.appendChild(wrap);

    function current() {
      var i;
      if (DESKTOP.matches) {
        for (i = 0; i < slides.length; i++) {
          if (getComputedStyle(slides[i]).display !== 'none') return i;
        }
      } else {
        for (i = 0; i < slides.length; i++) {
          if (slides[i].classList.contains('is-active')) return i;
        }
      }
      return 0;
    }

    function update() {
      var cur = current();
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === cur);
        if (i === cur) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
    }

    function goTo(i) {
      if (DESKTOP.matches) {
        if (thumbs[i]) thumbs[i].click();
        return;
      }
      var steps = i - current();
      var btn = sp.querySelector(steps > 0 ? '.splide__arrow--next' : '.splide__arrow--prev');
      if (!btn) return;
      var n = Math.abs(steps);
      (function tick() {
        if (n-- <= 0) return;
        btn.click();
        setTimeout(tick, 120);
      })();
    }

    new MutationObserver(update).observe(list, {
      attributes: true, subtree: true, attributeFilter: ['class', 'style', 'hidden']
    });
    if (DESKTOP.addEventListener) DESKTOP.addEventListener('change', update);
    window.addEventListener('resize', update);
    update();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // Gallery is rendered late by the theme – retry briefly
  var tries = 0, t = setInterval(function () {
    init();
    if (document.querySelector('.of-dots') || ++tries > 20) clearInterval(t);
  }, 300);
})();